import React, { Suspense, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import { PageSpinner } from '@shared/patterns';

const scrollPositions = new Map<string, number>();

export const ContentFrame: React.FC = () => {
  const mainRef = useRef<HTMLElement>(null);
  const location = useLocation();
  const navType = useNavigationType();

  // Save scroll position before leaving current route
  useEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl) return;

    return () => {
      scrollPositions.set(location.key, mainEl.scrollTop);
    };
  }, [location.key]);

  // Restore scroll position on back/forward (POP) or scroll to top on PUSH/REPLACE
  useEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl) return;

    if (navType === 'POP') {
      const saved = scrollPositions.get(location.key);
      if (saved !== undefined) {
        mainEl.scrollTop = saved;
      }
    } else {
      mainEl.scrollTop = 0;
    }
  }, [location.key, navType]);

  return (
    <div className="flex-1 min-w-0 flex flex-col h-full overflow-hidden bg-background">
      <main
        ref={mainRef}
        className="flex-1 overflow-y-auto overscroll-contain w-full px-[max(0.875rem,var(--safe-left))] py-4 pb-[calc(var(--mobile-nav-total)+1rem)] md:p-6"
      >
        <Suspense fallback={<PageSpinner />}>
          <div
            key={location.pathname}
            className="w-full motion-safe:animate-in motion-safe:fade-in-0 motion-safe:duration-150"
          >
            <Outlet />
          </div>
        </Suspense>
      </main>
    </div>
  );
};
